<vectronic-chips-filter-with-header
  [title]="title()"
  [availableFilterItems]="items()"
  [selectedItems]="value()"
  [isFilterHidden]="!expanded()"
  [disabled]="disabled()"
  (isFilterHiddenChange)="toggled.emit()"
  (selectedItemsChange)="onSelectedItemsChange($event)"
></vectronic-chips-filter-with-header>
